import {SearchComboboxBanner, SearchComboboxSkeleton} from "@pg-design/search-combobox-module";
import {PRICES_SEARCH_TEST_IDS} from "@pg-mono/test-ids";

import {PRICES_SEARCH_COPY} from "../../constants/prices_search";
import type {IPricesSearchModel} from "../../types/IPricesSearchModel";
import {PricesSearchEmpty} from "./PricesSearchEmpty";
import {PricesSearchFocusContent} from "./PricesSearchFocusContent";
import {type IPricesSearchListProps, PricesSearchSectionList} from "./PricesSearchSectionList";

interface IProps extends IPricesSearchListProps {
    model: IPricesSearchModel;
}

/**
 * Scrollable content of the dropdown and of the mobile layer - one rendering of the view model for both: the banner
 * (diacritics or network error), then the state (focus, results, loading skeleton or the empty state).
 */
export const PricesSearchResults = (props: IProps) => {
    const {model, ...listProps} = props;
    const {banner} = model;

    return (
        <>
            {banner?.kind === "diacritics" ? (
                <SearchComboboxBanner emphasis={banner.phrase} dataTestId={PRICES_SEARCH_TEST_IDS.BANNER}>
                    {PRICES_SEARCH_COPY.diacriticsBanner}
                </SearchComboboxBanner>
            ) : null}
            {banner?.kind === "error" ? (
                <SearchComboboxBanner
                    action={{label: banner.retry.label, ...listProps.combobox.getOptionProps(banner.retry.id)}}
                    dataTestId={PRICES_SEARCH_TEST_IDS.BANNER}
                >
                    {PRICES_SEARCH_COPY.errorBanner}
                </SearchComboboxBanner>
            ) : null}

            {model.state === "loading" ? <SearchComboboxSkeleton title={PRICES_SEARCH_COPY.loading} dataTestId={PRICES_SEARCH_TEST_IDS.SKELETON} /> : null}
            {model.state === "empty" && model.empty ? <PricesSearchEmpty empty={model.empty} combobox={listProps.combobox} mode={listProps.mode} /> : null}
            {model.state === "focus" || model.state === "error" ? (
                <PricesSearchFocusContent nearby={model.nearby} sections={model.sections} {...listProps} />
            ) : null}
            {model.state === "results" ? <PricesSearchSectionList sections={model.sections} {...listProps} /> : null}
        </>
    );
};
import {SearchComboboxBanner, SearchComboboxSkeleton} from "@pg-design/search-combobox-module";
import {PRICES_SEARCH_TEST_IDS} from "@pg-mono/test-ids";

import {PRICES_SEARCH_COPY} from "../../constants/prices_search";
import type {IPricesSearchModel} from "../../types/IPricesSearchModel";
import {PricesSearchEmpty} from "./PricesSearchEmpty";
import {PricesSearchFocusContent} from "./PricesSearchFocusContent";
import {type IPricesSearchListProps, PricesSearchSectionList} from "./PricesSearchSectionList";

interface IProps extends IPricesSearchListProps {
    model: IPricesSearchModel;
}

/**
 * Scrollable content of the dropdown and of the mobile layer - one rendering of the view model for both: the banner
 * (diacritics or network error), then the state (focus, results, loading skeleton or the empty state).
 */
export const PricesSearchResults = (props: IProps) => {
    const {model, ...listProps} = props;
    const {banner} = model;

    return (
        <>
            {banner?.kind === "diacritics" ? (
                <SearchComboboxBanner emphasis={banner.phrase} dataTestId={PRICES_SEARCH_TEST_IDS.BANNER}>
                    {PRICES_SEARCH_COPY.diacriticsBanner}
                </SearchComboboxBanner>
            ) : null}
            {banner?.kind === "error" ? (
                <SearchComboboxBanner
                    action={{label: banner.retry.label, ...listProps.combobox.getOptionProps(banner.retry.id)}}
                    dataTestId={PRICES_SEARCH_TEST_IDS.BANNER}
                >
                    {PRICES_SEARCH_COPY.errorBanner}
                </SearchComboboxBanner>
            ) : null}

            {model.state === "loading" ? <SearchComboboxSkeleton title={PRICES_SEARCH_COPY.loading} dataTestId={PRICES_SEARCH_TEST_IDS.SKELETON} /> : null}
            {model.state === "empty" && model.empty ? <PricesSearchEmpty empty={model.empty} combobox={listProps.combobox} mode={listProps.mode} /> : null}
            {model.state === "focus" || model.state === "error" ? (
                <PricesSearchFocusContent nearby={model.nearby} sections={model.sections} {...listProps} />
            ) : null}
            {model.state === "results" ? <PricesSearchSectionList sections={model.sections} {...listProps} /> : null}
        </>
    );
};
